/**
 * Submódulo "Projetos Executivos" — reconstrução NATIVA do mockup do CD
 * (mesmo visual/gráficos) com dados REAIS da planilha de Distribuição.
 *
 * A navegação (17 telas) fica na sidebar real do ERP (utils/modules.jsx),
 * cada link é uma rota /projetos-executivos/<grupo>/<slug>. Aqui derivamos o
 * slug da rota e passamos os ambientes reais (parser 48 colunas + join) já
 * mapeados para o shape do mockup.
 */
import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { useAmbientesComJoin } from "../../context/DadosContext";
import { useAuth } from "../../context/AuthContext";
import { mapRows } from "./peData";
import { peRequireAny } from "./pePerms";
import Pe from "./Pe";

function slugFrom(pathname) {
  const parts = String(pathname).replace(/\/+$/, "").split("/").filter(Boolean);
  const i = parts.indexOf("projetos-executivos");
  if (i < 0) return "visao-geral";
  const rest = parts.slice(i + 1);
  if (rest.length >= 2) return rest[1];
  if (rest.length === 1) return rest[0] === "ambientes" ? "ambientes" : "visao-geral";
  return "visao-geral";
}

export default function ProjetosExecutivos() {
  const { ambientes } = useAmbientesComJoin();
  const { hasAnyPermission } = useAuth();
  const location = useLocation();
  const rows = useMemo(() => mapRows(ambientes), [ambientes]);
  const slug = slugFrom(location.pathname);

  // Gate por página (auditoria RBAC 2026-07-02): a rota /projetos-executivos/*
  // aceita quem tem qualquer permissão do submódulo (PE_ROUTE_ANY no App.jsx);
  // aqui validamos a página ESPECÍFICA — guarda-chuva OU pe_<slug>:view.
  // hasAnyPermission já dá bypass para Master.
  if (!hasAnyPermission(peRequireAny(slug))) {
    return (
      <div style={{ padding: "48px 24px", textAlign: "center", color: "var(--ink-3)" }}>
        Você não tem permissão para acessar esta página.
      </div>
    );
  }

  return <Pe rows={rows} slug={slug} />;
}
